<template lang="html">
  <label
    class="checkbox-container"
    :class="[checkClasses]"
    @click.stop.prevent="toggleCheck"
  >
    <input type="checkbox" class="rounded"/>
    <span :class="checkBoxClass"></span>
  </label>
</template>

<script>
  export default {
    props: {
      model: [String, Boolean, Object, Number, Array],
      value: {
        type: [String, Boolean, Number, Object],
        default: 'on',
      },
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
      },
      checkBoxClass: {
        type: String,
        default() {
          return 'checkmark';
        },
      },
    },
    model: {
      prop: 'model',
      event: 'change',
    },
    computed: {
      isSelected() {
        if (this.isModelArray) {
          if (this.model.length > 0) {
            // If the values of the array supporting the checkbox are objects,
            // equality will be inferred throught the objects' IDs (the same ones
            // from the DB).
            if (this.model[0].constructor === Object) {
              return !!this.model.find((x) => x.id === this.value.id);
            } else {
              return this.model.includes(this.value);
            }
          }
        }
        if (this.isModelBoolean && this.value === 'on') {
          return this.model;
        }
        return this.model === this.value;
      },
      isModelArrayWithObjects() {
        return (
          Array.isArray(this.model) &&
          this.model.length > 0 &&
          this.model[0].constructor === Object
        );
      },
      isModelArray() {
        return Array.isArray(this.model);
      },
      isModelBoolean() {
        return typeof this.model === 'boolean';
      },
      checkClasses() {
        return {
          selected: this.isSelected,
          disabled: this.disabled,
        };
      },
    },
    methods: {
      removeItemFromModel(newModel) {
        const index = newModel.indexOf(this.value);
        if (index !== -1) {
          newModel.splice(index, 1);
        }
      },
      handleArrayWithObjectsCheckbox() {
        const index = this.model.findIndex(
          (value) => value.id === this.value.id
        );
        if (index !== -1) {
          this.model.splice(index, 1);
        } else {
          this.model.push(this.value);
        }
      },
      handleArrayCheckbox() {
        const index = this.model.findIndex((value) => value === this.value);
        if (index !== -1) {
          this.model.splice(index, 1);
        } else {
          this.model.push(this.value);
        }
      },
      handleStringCheckbox() {
        if (!this.isSelected) {
          this.$emit('change', this.value);
        } else {
          this.$emit('change', null);
        }
      },
      handleBooleanCheckbox() {
        this.$emit('change', !this.model);
      },
      toggleCheck() {
        if (!this.disabled) {
          if (this.isModelArrayWithObjects) {
            this.handleArrayWithObjectsCheckbox();
          } else if (this.isModelArray) {
            this.handleArrayCheckbox();
          } else if (this.isModelBoolean) {
            this.handleBooleanCheckbox();
          } else {
            this.handleStringCheckbox();
          }
        }
      },
    },
  };
</script>

<style scoped lang="stylus">
  /* ***** Import Global Stylus ***** */
  @import '~app/global-stylus';

  /* ***** Defaults ***** */
  /* Customize the label (the container) */
  .checkbox-container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 21px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    left: -999em;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 2px solid pl-slate;
    border-radius: 2px;
    background-color: #ffffff;
    transition: cubic-bezier(0.25, 0.8, 0.25, 1) 0.3s;
  }

  .checkmark-red {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 2px solid pl-slate;
    border-radius: 2px;
    background-color: #ffffff;
    transition: cubic-bezier(0.25, 0.8, 0.25, 1) 0.3s;
  }
  .selected > .checkmark-red {
    background-color: rgb(248, 113, 113);
    border: 2px solid rgb(248, 113, 113);
    transition: cubic-bezier(0.25, 0.8, 0.25, 1) 0.6s;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark-red:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .selected > .checkmark-red:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-container .checkmark-red:after {
    left: 5px;
    top: 1px;
    width: 6px;
    height: 11px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    transition: cubic-bezier(0.25, 0.8, 0.25, 1) 0.6s;
  }

  /* On mouse-over, add a grey background color */
  /* When the checkbox is checked, add a blue background */
  .selected > .checkmark {
    background-color: pl-primary;
    border: 2px solid pl-primary;
    transition: cubic-bezier(0.25, 0.8, 0.25, 1) 0.6s;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .selected > .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-container .checkmark:after {
    left: 5px;
    top: 1px;
    width: 6px;
    height: 11px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    transition: cubic-bezier(0.25, 0.8, 0.25, 1) 0.6s;
  }
</style>



// WEBPACK FOOTER //
// plCheckbox.vue?b894a56a